import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { PopoverController, NavController, AlertController, ToastController, LoadingController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-login-coinbase',
  templateUrl: './login-coinbase.component.html',
  styleUrls: ['./login-coinbase.component.scss'],
})
export class LoginCoinbaseComponent implements OnInit {
  terminoscondiciones
  terminoscondicionescheck
  email
	valid2=false

  constructor(
 		public popoverController: PopoverController,
     private alertCtrl: AlertController,
    private authService: AuthService,
  	private translate: TranslateService,

  ) { }

  ngOnInit() {
    this.getTerminosCondiciones()

  }
  seePolities(){
    console.log(this.terminoscondiciones)
    this.presentAlert('Terminos y condiciones', '', this.terminoscondiciones, '', '')
  }
  /**
  *  terminos y condiciones cliente
  */
  async getTerminosCondiciones(){
      // await this.myApp.presentLoadingAdvanced('LOADING WAIT', 'show');
    await this.authService.getTerminosCondiciones() 
    .subscribe(async (terminos:any) => {
      // console.log(cities)
      // await this.myApp.presentLoadingAdvanced('LOADING WAIT', 'dismiss');
      this.terminoscondiciones = terminos
    }, async (err) => {
      // await this.myApp.presentLoadingAdvanced('LOADING WAIT', 'dismiss');
      console.log(err);
      let msm, tit;
      tit = this.translate.store.translations[this.translate.store.currentLang]["WE ARE SORRY!"];
      if(err.error && err.error.msg)
        msm = (err.error.msg);
      // await this.myApp.presentAlert(tit, '', msm, '', '');
    });
  }
  /**
  *
  * validacion de errorres por mensaje
  *
  */
  async presentAlert(tit, subtit, message, rutaAcept, rutaCancel) {
    var titT = this.translate.store.translations[this.translate.store.currentLang][tit]
    var subtitT = this.translate.store.translations[this.translate.store.currentLang][subtit]
    var messageT = this.translate.instant(message) ? this.translate.instant(message): message
    const alert = await this.alertCtrl.create({
        header: tit? titT ? titT: tit:tit,
        subHeader: subtit?subtitT? subtitT: subtit:subtit,
        message: message ? messageT ? messageT : message: 'FAILED OPERATION',
        buttons: [
        {
            text: 'Aceptar',
            handler: () => {}
        }
        ], backdropDismiss: true
    });
    await alert.present();
  }
  click(){

    //this.valid2 = true
    console.log(this.terminoscondicionescheck)
  }
  updateValid(ev) {

  	if(ev == 'email'){
	  	let b:any = document.getElementById('email')
	 		if (b.value ) 
	 			this.email = b.value 
 			else this.email=''
  	}
    else if(ev == 'terminos'){
      let c:any = document.getElementById('terminoscondicionescheck')
      console.log(c)
      console.log(c.checked)
       if (c.checked == true ) 
         this.terminoscondicionescheck = true
       else this.terminoscondicionescheck=false
    }

  	console.log("email")
  	console.log(this.email)

  	// if(this.fecha_nac!==''  && this.address!=='' && this.tel!=='' && this.genero!==''  )
  	// 	this.valid2 = true
  	// else
  	// 	this.valid2 = false
    if(this.terminoscondicionescheck==false )
  	 	this.valid2 = true
    else
  	 	this.valid2 = false
  }
  Signup_coinbase(){
  	let body ={}
    
    let a:any = document.getElementById('email')
    if (a.value ) 
      this.email = a.value 
      
  	body = {
    	state: this.email,
  	}

		this.popoverController.dismiss(body);
  } 
}
